import React, { useState, useEffect } from 'react';
import { Modal, Button, Image, Spinner } from 'react-bootstrap';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import PaymentSuccess from './paymentSuccess';
import AddCreditCard from './addCreditCard';
import FetchingSpinner from '../basicComponents/loaderModal';

const PaymentModal = ({ show, onHide, name, icon, version, price, devName, price_period, onContinue, app }) => {
    const [cards, setCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState('');
    const [loading, setLoading] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [showAddCardModal, setShowAddCardModal] = useState(false);
    const [error, setError] = useState('');

    const getCards = async () => {
        try {
            const result = (await ObexRequestHandler.get('/cards', {}, true)).data || {};
            const { defaultCard, cards } = result;
            const formattedCards = cards.map(card => ({
                ...card,
                defaultCard: card.id === defaultCard,
            }));
            setCards(formattedCards);
            setSelectedCard(defaultCard || (cards.length > 0 ? cards[0].id : ''));
        } catch (error) {
            console.error('Error fetching cards:', error);
        }
    };

    const handleCardChange = (e) => {
        const value = e.target.value;
        if (value === 'addCard') {
            setShowAddCardModal(true);  // Mostrar modal para añadir tarjeta
        } else {
            setSelectedCard(value);  // Establece la tarjeta seleccionada
        }
    };

    const makePayment = async () => {
        setLoading(true);
        setError('');
        try {
            const payload = {
                api_product_id: app,
                version: version.replace(/\+/g, '.'),
                card_stripe_id: selectedCard,
            };
            const result = await ObexRequestHandler.post('/buy_api_product', payload);
            if (result.success) {
                setPaymentSuccess(true);
                onHide();  // Cierra el modal principal después de un pago exitoso
                onContinue();  // Llama a la función onContinue después de un pago exitoso
            } else {
                throw new Error(result.message || 'Payment failed');
            }
        } catch (error) {
            setError(error.message || 'Error occurred during payment.');
            setLoading(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (show) getCards();
    }, [show]);

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton className='mkt-modal-header'>
                <Modal.Title className="text-center mkt-modal-title">Add {name} to your account</Modal.Title>
            </Modal.Header>
            <Modal.Body className='mkt-modal-body'>
                {loading && <FetchingSpinner />}
                {!loading && !paymentSuccess && (
                    <div className="formWrapper">
                        <div className="">

                            {/*  <h2 className="text-center txt-20 c-modal">Review your payment and proceed.</h2> */}
                        </div>

                        <div className="productDetailCard mb-4">
                            <div className="top">
                                <p className="txt-16 txt-bold"> API Product Selected </p>
                            </div>

                            <div className="bottom">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="mr-3">
                                            <Image src={icon ? atob(icon) : 'defaultImagePath'} alt="App Icon" fluid />
                                        </div>
                                        <div>
                                            <h4 className="m-0 txt-bold txt-16">{name}</h4>
                                            <p className="m-0"> <span className="txt-bold c-brick">Version:</span> {version}</p>
                                            <p className="m-0">  {price_period}</p>
                                        </div>
                                    </div>
                                    <p className="txt-20 txt-bold">Price: ${price}</p>
                                </div>
                            </div>
                        </div>

                        <div className="productDetailCard mb-3">
                            <div className="bottom">

                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="txt-bold txt-16 m-0">Payment Method</p>
                                    <div>
                                        <select className="cardsSelector" value={selectedCard} onChange={handleCardChange}>
                                            {cards.map(card => (
                                                <option key={card.id} value={card.id}>
                                                    {card.brand} ****{card.last4}
                                                </option>
                                            ))}
                                            <option value="addCard">Add new card</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="productDetailCard">
                            <div className="top d-flex justify-content-between align-items-center">
                                <p className="txt-16 txt-bold  m-0"> Total price </p>
                                <p className="txt-20 m-0">
                                    <span className="txt-bold">${price} USD</span>
                                    {price_period === 'Monthly' && <span>/Month</span>}
                                    {price_period === 'Anually' && <span>/Year</span>}
                                    {price_period === 'One-time payment' && <span>/One time</span>}
                                </p>
                            </div>

                            <div className="bottom">
                                <div className="d-flex justify-content-between">
                                    <p>
                                        You will pay the full price, plus fees, at the start of each billing period. The first payment is <span className="txt-bold">${price} USD.</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {error && <p className="text-danger">{error}</p>}
                    </div>
                )}
                {paymentSuccess}
            </Modal.Body>
            <Modal.Footer className="justify-content-between pb-3 mkt-modal-footer">
                <button className='btn-ln-black' onClick={onHide}>Cancel</button>
                {!paymentSuccess && (
                    <button className='btn-brick' onClick={makePayment} disabled={loading || !selectedCard}>
                        {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Proceed to Payment'}
                    </button>
                )}
            </Modal.Footer>

            {showAddCardModal && <AddCreditCard show={showAddCardModal} handleClose={() => setShowAddCardModal(false)} />}
        </Modal>
    );
};

export default PaymentModal;
